<h1 class="main-title">Termos de Uso da Plataforma MZIC</h1>

<h2 class="section-heading">1. Quem somos e papéis de tratamento</h2>
<p class="text-content">
  <strong>Controladora:</strong>
  MZIC BRASIL S.A., CNPJ 60.978.531/0001-85, com sede na Av. Jorge João Saad,
  305, Sala 25, São Paulo/SP, CEP 05618-000.
</p>

<p class="text-content">
  Estes Termos regem o acesso e a utilização da plataforma eletrônica de
  investimento participativo da MZIC por usuários interessados em participar de
  oportunidades de investimento em Certificados de Recebíveis ("CRs") ofertados
  na modalidade "crowdfunding", nos termos da Resolução CVM 88.
</p>

<h2 class="section-heading">2. Termos definidos</h2>
<p class="text-content">
  <strong>"Certificados de Recebíveis (CRs)":</strong>
  São os valores mobiliários de securitização, emitidos nos termos da Lei
  14.430, lastreados em direitos creditórios decorrentes da exploração de obras
  musicais.
</p>
<p class="text-content">
  <strong>"CVM":</strong>
  A Comissão de Valores Mobiliários, autarquia federal responsável pela
  regulação e fiscalização do mercado de valores mobiliários no Brasil.
</p>
<p class="text-content">
  <strong>"Dashboard":</strong>
  Ambiente digital interno da Plataforma destinado ao acompanhamento de
  operações, posições e rendimentos.
</p>
<p class="text-content">
  <strong>"Investidor":</strong>
  Usuário que utiliza a Plataforma para adquirir Certificados de Recebíveis.
</p>
<p class="text-content">
  <strong>"Lei 14.430":</strong>
  Lei Federal nº 14.430, de 3 de agosto de 2022, conforme em vigor.
</p>
<p class="text-content">
  <strong>"LGPD":</strong>
  Lei Federal nº 13.709, de 14 de agosto de 2018, conforme em vigor (Lei Geral
  de Proteção de Dados).
</p>
<p class="text-content">
  <strong>"Plataforma":</strong>
  A plataforma eletrônica de investimento participativo da MZIC BRASIL S.A.,
  devidamente habilitada pela CVM nos termos do Ato Declaratório nº 23.964, de
  29 de Setembro de 2025.
</p>
<p class="text-content">
  <strong>"Resolução CVM 88":</strong>
  Resolução da CVM nº 88, de 27 de abril de 2022, conforme em vigor.
</p>
<p class="text-content">
  <strong>"Termos":</strong>
  Estes "Termos de Uso – Usuários do Aplicativo (Investidores)".
</p>
<p class="text-content">
  <strong>"Usuário":</strong>
  Pessoa física ou jurídica cadastrada na Plataforma, incluindo seus
  representantes legais, conforme aplicável.
</p>
<p class="text-content">
  <strong>"Carteira Inteligente/Conta Digital Inteligente":</strong>
  credencial tecnológica associada à conta do Usuário para autenticação,
  assinatura de operações e guarda de chaves, podendo se apoiar em
  infraestrutura on-chain.
</p>

<h2 class="section-heading">3. Aceitação dos Termos</h2>
<p class="text-content">
  Ao cadastrar-se, o Usuário declara ter lido, compreendido e aceito
  integralmente estes Termos. Caso não concorde, não deverá utilizar a
  Plataforma.
</p>

<h2 class="section-heading">4. Cadastro, elegibilidade e compliance</h2>

<h3 class="subsection-heading">4.1 Elegibilidade mínima</h3>
<p class="text-content">
  <strong>(i) Pessoa física (PF):</strong>
  ser maior de 18 anos e informar, ao menos, nome completo, e-mail, telefone,
  data de nascimento e CPF;
  <strong>(ii) Pessoa jurídica (PJ):</strong>
  informar razão social/nome fantasia, CNPJ, e-mail e telefone de contato, além
  dos dados do representante legal (nome, CPF e data de nascimento).
</p>

<h3 class="subsection-heading">
  4.2 Requisitos de compliance e documentação adicional
</h3>
<p class="text-content">
  A Plataforma poderá solicitar documentos adicionais (comprovantes,
  questionário de suitability, etc.) conforme regras da CVM e demais
  autoridades. Caso o Usuário realize investimento(s) que, individual ou
  conjuntamente considerados, ultrapasse(m) o limite de R$ 20.000,00 (vinte mil
  reais), será exigido o envio de documentação adicional, incluindo comprovante
  de renda e comprovante de endereço (para PF) ou documentos societários e de
  qualificação do representante (para PJ), sem prejuízo de outras solicitações.
  A Plataforma poderá solicitar outros documentos ou informações sempre que
  necessário para atender requisitos legais, regulatórios, de prevenção à fraude
  ou de segurança. O descumprimento das exigências poderá resultar em suspensão
  ou bloqueio da conta do Usuário.
</p>

<h3 class="subsection-heading">4.3 KYC/AML e dados sensíveis</h3>
<p class="text-content">
  O Usuário autoriza a validação de identidade (inclui documento e
  selfie/biometria) por fornecedores especializados de KYC/KYB/AML. A ausência
  de verificação poderá impedir a realização de investimentos e/ou saques.
</p>

<h3 class="subsection-heading">4.4 Atualização cadastral</h3>
<p class="text-content">
  O Usuário se compromete a manter seus dados exatos e atualizados.
</p>

<h2 class="section-heading">
  5. Declarações regulatórias e natureza dos serviços
</h2>
<p class="text-content">
  A CVM não garante a veracidade das informações, a qualidade dos ativos ou a
  conformidade das ofertas. A MZIC não presta consultoria de investimentos, não
  recomenda ativos, não gere recursos de terceiros e não atua como instituição
  financeira. A decisão de investir é exclusiva do Usuário, que deve avaliar os
  documentos da oferta.
</p>

<h2 class="section-heading">6. Avisos de risco</h2>
<p class="text-content">
  O Investidor reconhece que:
  <strong>(i)</strong>
  há risco de perda total ou parcial do capital;
  <strong>(ii)</strong>
  não há garantia de liquidez ou de rentabilidade;
  <strong>(iii)</strong>
  o desempenho dos valores mobiliários depende de fatores de mercado e do
  desempenho dos direitos creditórios; e
  <strong>(iv)</strong>
  é sua responsabilidade ler os documentos da oferta, incluindo alertas de risco
  e informações essenciais.
</p>

<h2 class="section-heading">7. Responsabilidades do investidor</h2>
<p class="text-content">
  O Investidor é responsável pela veracidade das informações prestadas, pelo
  cumprimento das normas aplicáveis e pela guarda de suas credenciais. O uso da
  Plataforma para fins ilícitos ou em desacordo com estes Termos pode ensejar
  suspensão ou cancelamento da conta, sem prejuízo das medidas legais cabíveis.
</p>

<h2 class="section-heading">8. Conta, segurança e Carteira Inteligente</h2>

<h3 class="subsection-heading">8.1 Criação e segurança da conta</h3>
<p class="text-content">
  O Usuário deve proteger suas credenciais e dispositivos. Qualquer atividade
  suspeita deve ser comunicada imediatamente.
</p>

<h3 class="subsection-heading">
  8.2 Carteira Inteligente/infraestrutura on-chain
</h3>
<p class="text-content">
  A Carteira Inteligente é um meio tecnológico para autenticar e assinar
  operações na Plataforma, podendo usar endereços on-chain. Endereços on-chain e
  registros em blockchain têm natureza pública e imutável.
</p>

<h3 class="subsection-heading">8.3 Recuperação e suporte</h3>
<p class="text-content">
  A MZIC poderá oferecer mecanismos de recuperação/contingência de acesso (ex.:
  chaves sociais, provedores de custódia), sem obrigação de guarda de senhas do
  Usuário.
</p>

<h2 class="section-heading">9. Escopo dos serviços da Plataforma</h2>
<p class="text-content">
  A Plataforma poderá ofertar, conforme a regulamentação aplicável,
  oportunidades de investimento em CRs lastreados em direitos creditórios
  oriundos da indústria musical. A Plataforma disponibilizará meios para o
  acompanhamento das operações e recebimento de rendimentos, observadas as
  condições específicas de cada Oferta.
</p>

<h2 class="section-heading">10. Privacidade, cookies e analytics</h2>

<h3 class="subsection-heading">10.1 Política de Privacidade</h3>
<p class="text-content">
  O tratamento de dados pessoais segue a Política de Privacidade da Plataforma
  MZIC, disponível em /privacy.
</p>

<h3 class="subsection-heading">10.2 Cookies e preferências</h3>
<p class="text-content">
  Usamos cookies e tecnologias semelhantes para autenticação, segurança,
  preferências e analytics.
</p>

<h3 class="subsection-heading">10.3 PostHog (analytics de uso e sessão)</h3>
<p class="text-content">
  Utilizamos PostHog para métricas de uso e, quando habilitado, gravação de
  sessão/heatmaps exclusivamente para diagnóstico de UX.
</p>

<h2 class="section-heading">
  11. Provedores de serviços terceirizados essenciais
</h2>
<p class="text-content">
  Ao usar a Plataforma, você concorda que certos serviços são prestados por
  terceiros, cujos termos e políticas também se aplicam, conforme o caso:
</p>
<ul class="content-list">
  <li>Plaid Technologies, Inc. – KYC/AML.</li>
  <li>Banco Transfero – conta/pagamentos e liquidação.</li>
  <li>PostHog – analytics (eventos e, se habilitado, sessão).</li>
</ul>
<p class="text-content">
  Outros provedores poderão ser utilizados para computação em nuvem, prevenção a
  fraude, mensageria e suporte.
</p>

<h2 class="section-heading">12. Propriedade intelectual</h2>
<p class="text-content">
  Todos os direitos relacionados à Plataforma, marcas, códigos, interfaces e
  conteúdos são de titularidade da MZIC ou de seus licenciadores. É vedado
  copiar, modificar, distribuir, realizar engenharia reversa ou criar obras
  derivadas sem autorização expressa.
</p>

<h2 class="section-heading">13. Tributação</h2>
<p class="text-content">
  O Investidor é responsável pelo cumprimento de suas obrigações tributárias
  (inclusive declarações e recolhimentos). A MZIC poderá efetuar retenções
  legais quando aplicáveis e disponibilizar informes de rendimentos, se cabível.
</p>

<h2 class="section-heading">14. Comunicações e aceite eletrônico</h2>
<p class="text-content">
  O Usuário consente em receber comunicações por meios eletrônicos (e-mail,
  notificações no app/web) e reconhece como válido o aceite eletrônico nos
  fluxos da Plataforma, cujos logs de concordância poderão ser utilizados como
  prova.
</p>

<h2 class="section-heading">15. Modificações destes Termos</h2>
<p class="text-content">
  A MZIC poderá modificar estes Termos a qualquer tempo, mediante comunicação
  prévia ao Usuário por e-mail e/ou pela própria Plataforma. A continuidade de
  uso após a comunicação implica aceitação da versão vigente.
</p>

<h2 class="section-heading">16. Lei aplicável e foro</h2>
<p class="text-content">
  Aplica-se a legislação brasileira. Fica eleito o Foro da Comarca de São
  Paulo/SP, com exclusão de qualquer outro, para dirimir eventuais disputas
  relacionadas a estes Termos.
</p>

<h2 class="section-heading">17. Contatos e canais legais</h2>
<p class="text-content">
  Dúvidas sobre estes Termos e/ou denúncias podem ser enviadas para
  <strong>legal&#64;mzic.io</strong>
  .
</p>

<p class="text-content">
  <strong>Vigência:</strong>
  estes Termos entram em vigor na data de sua publicação e permanecem válidos
  enquanto o Usuário mantiver conta ou utilizar a Plataforma.
</p>
